import React from 'react';
import classNames from 'classnames';
import styles from './ServiceLinkCard.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Kicker, UI_KickerProps } from 'ui/components/1-atoms/Kicker/Kicker';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import RightArrow from 'ui/icons/icon-right-button-arrow.svg';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';

export interface UI_ServiceLinkCardProps {
	className?: string;
	globalTheme?: string;
	heading: string;
	kicker?: UI_KickerProps;
	link?: {
		url: string;
		target?: string;
		name?: string;
	};
	text?: string;
	separateLink?: boolean;
}

export const UI_ServiceLinkCard: React.FC<UI_ServiceLinkCardProps> = ({ className, globalTheme, heading, kicker, link, text, separateLink }) => {
	const hasKicker = kicker?.firstWord || kicker?.secondWord;

	const renderLinkContent = () => (
		<>
			{hasKicker && <UI_Kicker {...kicker} className={styles.ServiceLinkCard_kicker} />}
			<UI_Heading headingLevel="h3" className={styles.ServiceLinkCard_heading}>
				{heading}
				{link && (
					<UI_Icon size={text ? 'md' : 'lg'} className={styles.ServiceLinkCard_linkIcon}>
						<RightArrow />
					</UI_Icon>
				)}
			</UI_Heading>
			{!separateLink && text && <UI_RichText content={text} className={styles.ServiceLinkCard_text} />}
		</>
	);

	return (
		<div
			className={classNames(
				styles.ServiceLinkCard,
				{ [styles.ServiceLinkCard___withText]: text != null },
				{ [styles.ServiceLinkCard___withoutLink]: link === null },
				{ [styles.ServiceLinkCard___withKicker]: hasKicker },
				className,
			)}
		>
			<UI_Link className={styles.ServiceLinkCard_link} href={link?.url} target={link?.target} title={link?.name} noUnderline>
				{renderLinkContent()}
			</UI_Link>
			{separateLink && text && <UI_RichText content={text} className={styles.ServiceLinkCard_text} />}
		</div>
	);
};
